import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=c997c496&scoped=true&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=c997c496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997c496",
  null
  
)

export default component.exports